import React from "react"
import {
    renderRichText,
} from "gatsby-source-contentful/rich-text"
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types"
import { Options } from "@contentful/rich-text-react-renderer"
import { Bold, Heading1, Heading2, Heading3, Heading4, Text } from "./Markdown"
import { useLocale, useLocalPath } from "../../../hooks";
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { mapLangSelector } from "../../../utils/mapping"

import Quote from '../../../static/quote.svg'

export const RichText = ({ content }) => {
    const locale = useLocale()
    const options: Options = {
        renderMark: {
            [MARKS.BOLD]: (text) => <Bold>{text}</Bold>,
            [MARKS.ITALIC]: (text) => {
                return <em className="rich-text-italic">{text}</em>
            },
            [MARKS.CODE]: (text) => {
                return <span className="rich-text-notes">{text}</span>
            }
        },
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data
                return (
                    <a
                        href={uri}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Link opens in a new window"
                        title="Link opens in a new window"
                    >{children} </a>
                )
            },
            [INLINES.ENTRY_HYPERLINK]: ({
                data: {
                    target: {
                        slug
                    }
                }
            }, children) => {
                return (
                    <Link to={useLocalPath(slug)} className="rich-text-a"><span>{children}</span></Link>
                )
            },
            [INLINES.EMBEDDED_ENTRY]: (
                node
            ) => {
                if (!node && !node.data && !node.data.target) return (<></>)
                const {
                    data: {
                        target
                    }
                } = node

                switch (target.__typename) {
                    case "ContentfulSectionContent":
                        return (
                            <span className="">
                                <RichText content={target.content} />
                            </span>
                        )
                    case "ContentfulComponentLink":
                        return (
                            <span>
                                <GatsbyImage
                                    image={target.image?.gatsbyImageData}
                                    alt={target.image?.title}
                                    objectFit="contain"
                                    className="margin-5"
                                />
                            </span>
                        )

                }
            },
            [BLOCKS.HEADING_1]: (node, children) => <Heading1>{children}</Heading1>,
            [BLOCKS.HEADING_2]: (node, children) => <Heading2>{children}</Heading2>,
            [BLOCKS.HEADING_3]: (node, children) => <Heading3>{children}</Heading3>,
            [BLOCKS.HEADING_4]: (node, children) => <Heading4>{children}</Heading4>,
            [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
            [BLOCKS.EMBEDDED_ASSET]: (node) => {
                const { gatsbyImageData, title } = node.data.target
                return (
                    <GatsbyImage
                        image={gatsbyImageData}
                        alt={`${title} | ${mapLangSelector[locale]}`}
                        className="richtext-image"
                        objectFit="contain"
                    />
                )
            },
            [BLOCKS.QUOTE]: (node, children) => {
                return (
                    <div className="blockquote-container">
                        <Quote className="blockquote-quote" />
                        <blockquote className="blockquote-content">
                            {children}
                        </blockquote>
                    </div>
                )
            }
        },
    }
    if (content && content.raw) {
        return (
            <article className="blog-body">{renderRichText(content, options)}</article>
        )
    }
    else {
        return (
            <div></div>
        )
    }
}